module.exports = __webpack_public_path__ + "images/application/templates/trial@2x-00655307.png";